module.exports = __webpack_public_path__ + "img/top2.18f85041.png";